import React from "react";
import Box from "@mui/material/Box";

/**
 * DocumentLayout
 * A layout for documents using MUI v5 Box + sx
 */
function DocumentLayout({ children }) {
  return <Box sx={{ px: 1.5 }}>{children}</Box>;
}

export default DocumentLayout;
